import { PRIVATE } from '@/plugins/acl/const'

const recruitment = [
  // {
  //   path: '/recruitment/board',
  //   name: 'recruitment-board',
  //   meta: {
  //     layout: 'content',
  //     resource: PRIVATE.ATS.BOARD,
  //   },
  //   component: () => import('@/views/recruitment/board/BoardView.vue'),
  // },
  {
    path: '/recruitment/jobs',
    name: 'recruitment-jobs-list',
    component: () => import('@/views/recruitment/jobs/job-list/JobList.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.ATS.JOBS,
    },
  },
  {
    path: '/recruitment/jobs/:id',
    name: 'recruitment-job-view',
    component: () => import('@/views/recruitment/jobs/job-view/JobView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.ATS.JOB,
      breadCrumb(context) {
        return [
          {
            text: 'jobs',
            useI18n: true,
            to: { name: 'recruitment-jobs-list' },
          },
          {
            text: context.jobName,
          },
        ]
      },
    },
  },
  {
    path: '/recruitment/jobs/:jobId/candidate/:candidateId',
    name: 'recruitment-candidate-view',
    component: () => import('@/views/recruitment/jobs/candidate-view/CandidateView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.ATS.JOB_CANDIDATE,
      breadCrumb(context) {
        return [
          {
            text: 'jobs',
            useI18n: true,
            to: { name: 'recruitment-jobs-list' },
          },
          {
            text: context.jobName,
            useI18n: false,
            to: {
              name: 'recruitment-job-view',
              params: {
                id: context.jobId,
              },
            },
          },
          {
            text: context.candidateName,
            useI18n: false,
          },
        ]
      },
    },
  },
  {
    path: '/apply/:id',
    name: 'recruitment-job-apply-form',
    component: () => import('@/views/recruitment/jobs/ApplyForm.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: false,
    },
  },
  {
    path: '/recruitment/candidates',
    name: 'recruitment-candidates-list',
    component: () => import('@/views/recruitment/candidates/candidates-list/CandidatesList.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.ATS.CANDIDATES,
    },
  },
  {
    path: '/recruitment/candidates/:id',
    name: 'recruitment-candidates-entry-view',
    component: () => import('@/views/recruitment/candidates/candidates-entry-view/CandidatesEntryView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.ATS.CANDIDATES,
      breadCrumb(context) {
        return [
          {
            text: 'candidates',
            useI18n: true,
            to: { name: 'recruitment-candidates-list' },
          },
          {
            text: context.candidateEntryName,
            useI18n: false,
          },
        ]
      },
    },
  },
  {
    path: '/candidates/sign-up',
    name: 'recruitment-candidates-sign-up-form',
    component: () => import('@/views/recruitment/candidates/CandidatesSignUp.vue'),
    meta: {
      layout: 'blank',
      resource: 'Public',
      redirectIfLoggedIn: false,
    },
  },
  {
    path: '/recruitment/processes',
    name: 'recruitment-processes-list',
    component: () => import('@/views/recruitment/processes/list/WorkflowList.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.TEMPLATE.WORKFLOW,
    },
  },
  {
    path: '/recruitment/processes/:id',
    name: 'recruitment-process-view',
    component: () => import('@/views/recruitment/processes/view/WorkflowView.vue'),
    meta: {
      layout: 'content',
      resource: PRIVATE.TEMPLATE.WORKFLOW,
      breadCrumb(context) {
        return [
          {
            text: 'processes',
            useI18n: true,
            to: { name: 'recruitment-processes-list' },
          },
          {
            text: context.workflowTemplateName,
            useI18n: false,
          },
        ]
      },
    },
  },
]

export default recruitment
